module.exports = __webpack_public_path__ + "img/slide-img-03.fd65a57c.png";